import { Box, Stack, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { WorkflowNodeDisplayData } from 'src/pages/Settings/workflows/utils/workflow-helpers';
import { BaseNode } from './base-node';

const FooterContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  pointerEvents: 'none',
  fontSize: '0.65rem',
  fontWeight: 700,
  marginTop: theme.spacing(1),
}));

const ConditionPill = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: 'success' | 'neutral' }>(({ theme, variant }) => {
  const isSuccess = variant === 'success';
  return {
    paddingInline: theme.spacing(1),
    paddingBlock: theme.spacing(0.25),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${
      isSuccess ? theme.palette.success.light : theme.palette.custom.OV.sys.outline
    }`,
    color: isSuccess ? theme.palette.success.main : theme.palette.custom.OV.sys.outline,
    backgroundColor: isSuccess
      ? alpha(theme.palette.success.light, 0.2)
      : theme.palette.custom.OV.sys.surfaceContainer,
    marginLeft: isSuccess ? theme.spacing(6) : theme.spacing(13),
  };
});

const ConditionalNodeComponent = (props: NodeProps<WorkflowNodeDisplayData>) => {
  return (
    <BaseNode
      {...props}
      sourceHandles={[
        { id: 'if-true', left: '25%' },
        { id: 'if-false', left: '75%' },
      ]}
      footer={
        <FooterContainer>
          <ConditionPill variant="success">IF</ConditionPill>
          <ConditionPill variant="neutral">ELSE</ConditionPill>
        </FooterContainer>
      }
    />
  );
};

ConditionalNodeComponent.displayName = 'ConditionalNode';

export const ConditionalNode = memo(ConditionalNodeComponent);
